import './style.scss';

import { Button_Style, Button_Type } from 'shared/ui/Button/Button';
import { FC, useContext, useEffect, useState } from 'react';

import Alert from 'shared/ui/Alert';
import Button from 'shared/ui/Button';
import Input from 'shared/ui/Input';
import Loader from 'shared/ui/Loader';
import Snackbar from 'shared/ui/Snackbar';
import { UserContext } from "features/account";
import { invitation } from "features/invitation"
import { ReactComponent as IconSponsorship} from "../../assets/img/Verification.svg";
import Checkbox from 'shared/ui/Checkbox';
import SponsorShipModal from '../SponsorShipModal';
import { sendResultByEmail } from "features/share-id";
import BorderAnimate from "../BorderAnimate";


type SponsoCreditsProps = {
  data?:any
  applicant_id?: string;
}

const SponsoCredits: FC<SponsoCreditsProps> = ({data, applicant_id}) => {
  const [email, setEmail] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { user } = useContext(UserContext)
  const userType = user?.type;
  const [showSponsorModal, setShowSponsorModal] = useState<boolean>(false);

  const [isOwner, setIsOwner] = useState(false);

  const handleSendResult = async () => {
    setIsLoading(true)
    try {
     
      setIsLoading(false)
      sendResultByEmail(email, userType, data, isOwner, applicant_id);
      setSuccessMessage('Resultat envoyé avec succès.')
      setEmail('')
    } catch (error: any) {
      setIsLoading(false)
      console.log(error)
      setErrorMessage(error.response.data.error)
    }
  }

  const iconProps = {
    fill: "#272f91",
    width: "32px",
  };


  const handleCheckboxChange = (e: any) => {
    setIsOwner(e.target.checked);
    console.log(isOwner);
  
    // Perform any action based on the checkbox state
  };

  const handleSubmit = () => {
    if (!email) {
      setErrorMessage('Veuillez entrer un email valide.');
      return;
    }
    if (!email.includes('@')) {
      setErrorMessage('Veuillez entrer un email valide.');
      return;
    }
    if (errorMessage) {
      setErrorMessage('');
    }
    handleSendResult();
  };

  const handleInputChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);
    setErrorMessage('');
    setSuccessMessage('');
  };

  return (
    <div className="SponsoCredits">
      {
        showSponsorModal && (
          <SponsorShipModal isOpen={showSponsorModal}
              onClose={() => setShowSponsorModal(false)}
          />
          )
      }
      <BorderAnimate>
        <Snackbar title="Partager le résultat de l’analyse" logo={<IconSponsorship {...iconProps}/>}>
          {/*<p>ID Protect a mis en place un système de parrainage qui vous permet de gagner des crédits à chaque partage. </p>*/}
          <p className="font-S">Vous pouvez partager le résultat en l'envoyant par email.</p>
          <Checkbox
              className="font-SM"
              label={'Je suis le propriétaire de ce document'}
              onChange={handleCheckboxChange}></Checkbox>
          {errorMessage && <Alert type="error" showDefaultIcon={false}>{errorMessage}</Alert>}
          {successMessage && <Alert type="success" showDefaultIcon={false}>{successMessage}</Alert>}
          {isLoading && <Loader />}
          <Input placeholder="Email" className='mb-0' onChange={(e) => setEmail(e.target.value)} type="email" value={email} />
          <div className="d-flex justify-content-center text-center align-items-center gap-05 ml-2">
            <Button type={Button_Type.PRIMARY} style={Button_Style.OUTLINED} label='Envoyer' className='text-center' onClick={() => handleSubmit()} />

            <u
                className="pointer text-warning font-SM"
                onClick={() => {
                  setShowSponsorModal(!showSponsorModal);
                }}
            >Gagner des credits de vérification
            </u>
          </div>
        </Snackbar>
      </BorderAnimate>
    </div>
  );
}

export default SponsoCredits;
